import {
  Checkbox,
  Divider,
  FormControl,
  FormControlLabel,
  Radio,
  RadioGroup,
  Typography,
} from '@mui/material'
import React, { useState } from 'react'
import {
  DateInput,
  ImageUpload,
  SelectField,
  StyledButton,
  TextFields,
} from '../../../../../../components'
import { Buttons } from '../../School/SchoolRegistration/components/Steps'
import { useFormik } from 'formik'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import { useGlobal, usePostApi } from '../../../../../../shared'
import { getImageURL, urls } from '../../../../../../shared/config'
import { setLoader, setRefreshPage } from '../../../../../../redux/globalSlice'
import { useDispatch } from 'react-redux'
import { InfoField } from '../../School/PopOver/SchoolInfo'
// import { uploadImageToS3 } from '../../../../../../shared/config/S3Utils'
import { highestInt } from '../../../../../../shared/utils/constants'
import { backarrow, SuccesAnimation } from '../../../../../../assets/images'
import { AadharImage } from '../../../../../../components/ImageUploader/ImageUploader'
import { createFileChangeHandler } from '../../../../../../shared/lib'
import classes from './StudentForm.module.css'
import { useNavigate } from 'react-router-dom'
import { uploadImageToS3 } from '../../../../../../shared/config/S3Utils'
import { StudentSucess } from './StudentSuccess'
// import uploadImageToS3 from '../../../../../../shared/config/S3Utils'

const genderOptions = [
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' },
]
const categoryOptions = [
  { label: 'General', value: 'General' },
  { label: 'SC', value: 'SC' },
  { label: 'ST', value: 'ST' },
  { label: 'OBC', value: 'OBC' },
]
const monthOptions = [
  { label: 'January', value: 'January' },
  { label: 'February', value: 'February' },
  { label: 'March', value: 'March' },
  { label: 'April', value: 'April' },
  { label: 'May', value: 'May' },
  { label: 'June', value: 'June' },
  { label: 'July', value: 'July' },
  { label: 'August', value: 'August' },
  { label: 'September', value: 'September' },
  { label: 'October', value: 'October' },
  { label: 'November', value: 'November' },
  { label: 'December', value: 'December' },
]

const stepFields = {
  1: ['studentName', 'studentRollNo', 'batch', 'admission_month', 'gender', 'dob', 'caste'],
  2: ['fatherContact', 'address1', 'city', 'state', 'zipCode', 'email'],
  // 3: ['pen', 'appar_id', 'aadharNumber', 'aadharImage', 'birthCertificate'],
  4: ['gradeVal', 'section'],
  5: ['route', 'stop', 'van', 'transport_start_month', 'transport_end_month'],
  6: [
    'prev_school',
    'prev_school_city',
    'prev_school_board',
    'prev_school_mobile_number',
    'tc',
    'prev_marksheet',
  ],
  7: [
    'fatherName',
    // '',
    'fatherAge',
    'fatherAddress1',
    'fatherCity',
    'motherName',
    'motherContact',
    'motherAge',
    'fatherCaste',
    'fatherAadhar',
    'father_email',
    'motherAadhar',
    'fatherImage',
    'motherImage',
  ],
}
const StudentForm = ({ customRole, userSchoolId, success, setSuccess }) => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [step, setStep] = React.useState(1)
  // const [success, setSuccess] = React.useState(1)
  const { postApi } = usePostApi()
  const [studentID, setStudentId] = useState()
  // const [image, setImage] = useState()
  // const [sGrade, setSGrade] = useState()
  // const [Section, setSection] = useState()
  // const success=true
  const handleClose = () => {
    if (step === 1) {
      // Optional: ask if they really want to discard
      // if (window.confirm("Discard changes and go back to dashboard?")) {

      // }
      navigate('/dashboard')
    } else {
      setStep((prev) => prev - 1)
    }
  }

  const [sectionMapID, setSectionMapID] = useState()
  const initialValues = {
    schoolName: '',
    studentName: '',
    studentRollNo: '',
    // category: '',
    dob: '',
    gender: '',
    section: '',
    gradeVal: '',
    contactNumber: '',
    emergencyNumber: '',
    caste: '',
    address1: '',
    address2: '',
    city: '',
    state: '',
    zipCode: '',
    fatherName: '',
    fatherContact: '',
    father_email: '',
    fatherAge: '',
    fatherAddress1: '',
    fatherAddress2: '',
    fatherCity: '',
    fatherState: '',
    fatherZip: '',
    fatherCaste: '',
    fatherAdd: '',
    fatherAadhar: '',
    fatherImage: '',
    motherName: '',
    motherContact: '',
    motherAge: '',
    // motherAddress1: '',
    // motherAddress2: '',
    // motherCity: '',
    // motherState: '',
    // motherZip: '',
    // motherCaste: '',
    motherAadhar: '',
    motherImage: '',
    discountFee: '',
    transportFee: '',
    MiscFee: '',
    studentImage: '',
    aadharImage: '',
    aadharNumber: '',
    alternateContact: '',
    van_facility: 'required',
    batch: '',
    admission_month: '',
    emergencyNumber: '',
    email: '',
    pen: '',
    appar_id: '',
    birthCertificate: '',
    route: '',
    stop: '',
    van: '',
    // effect_from: '',
    prev_school: '',
    prev_school_city: '',
    prev_school_board: '',
    prev_school_mobile_number: '',
    tc: '',
    prev_marksheet: '',
    transport_start_month: '',
    transport_end_month: '',
  }



  const handleFileChange = (event, fieldName) => {
    const selectedFile = event.target.files[0]
    formik.setFieldValue(fieldName, selectedFile)
  }

  const step1Schema = Yup.object({
    studentName: Yup.string().trim().required('Student Name is required'),
    studentRollNo: Yup.string().trim().required('Registration No is required'),
    batch: Yup.string().trim().required('Batch is required'),
    admission_month: Yup.string().required('Admission Month is required'),
    gender: Yup.string().required('Gender is required'),
    dob: Yup.string().required('Date of Birth is required'),
    // caste: Yup.string().required('Caste is required'),   ← add if you want it mandatory
  })

  const step2Schema = Yup.object({
    fatherContact: Yup.string()
      .required("Father's contact is required")
      .matches(/^[6-9]\d{9}$/, 'Enter valid 10-digit Indian mobile number')
      .min(10, 'Must be exactly 10 digits')
      .max(10, 'Must be exactly 10 digits'),
    address1: Yup.string().trim().required('Address is required'),
    city: Yup.string().trim().required('City is required'),
    state: Yup.string().trim().required('State is required'),
    zipCode: Yup.string()
      .required('PIN code is required')
      .matches(/^\d{6}$/, 'PIN code must be exactly 6 digits'),
    // email: Yup.string().email('Invalid email').required('Email is required'),
  })

  // const step3Schema = Yup.object({
  //   // pen: Yup.string()
  //   //   .required('Permanent Education Number (PEN) is required')
  //   //   .trim()
  //   //   .min(1, 'PEN cannot be empty'),

  //   // appar_id: Yup.string()
  //   //   .required('Apaar ID is required')
  //   //   .trim()
  //   //   .min(1, 'Apaar ID cannot be empty'),

  //   // aadharNumber: Yup.string()
  //   //   .nullable()
  //   //   .matches(/^\d{12}$/, 'Aadhaar must be exactly 12 digits')
  //   //   .when('aadharImage', {
  //   //     is: (val) => !!val,
  //   //     then: (schema) => schema.required('Aadhaar number is required when image is uploaded'),
  //   //     otherwise: (schema) => schema.nullable(),
  //   //   }),
  // })
  const step4Schema = Yup.object({
    gradeVal: Yup.number()
      .typeError('Please select a valid grade')
      .required('Grade is required')
      .positive('Invalid grade ID')
      .integer('Invalid grade ID'),

    section: Yup.number()
      .typeError('Please select a valid section')
      .required('Section is required')
      .positive('Invalid section ID')
      .integer('Invalid section ID'),
  })

  const step5Schema = Yup.object({
    // van_facility: Yup.boolean().required(),
    route: Yup.string().when('van_facility', {
      is: true,
      then: (s) => s.required('Route is required when transport is needed'),
      otherwise: (s) => s.nullable(),
    }),
    stop: Yup.string().when('van_facility', {
      is: true,
      then: (s) => s.required('Stop is required'),
      otherwise: (s) => s.nullable(),
    }),
    van: Yup.string().when('van_facility', {
      is: true,
      then: (s) => s.required('Van is required'),
      otherwise: (s) => s.nullable(),
    }),
    transport_start_month: Yup.string().when('van_facility', {
      is: true,
      then: (s) => s.required('Start month is required'),
      otherwise: (s) => s.nullable(),
    }),
    transport_end_month: Yup.string().when('van_facility', {
      is: true,
      then: (s) => s.required('End month is required'),
      otherwise: (s) => s.nullable(),
    }),
  })

  const step6Schema = Yup.object({
    // all optional
  })
  const step7Schema = Yup.object({
    fatherName: Yup.string().trim().required("Father's name is required"),
    // fatherContact: Yup.string()
    //   .required("Father's contact is required")
    //   .matches(/^[6-9]\d{9}$/, 'Enter valid 10-digit number'),
    fatherAge: Yup.string()
      .required("Father's age is required")
      .matches(/^\d+$/, 'Age must be numbers only')
      .test('len', 'Age must be 2 or 3 digits', (val) => val.length >= 2 && val.length <= 3)
      .test('range', 'Age 18–100', (val) => {
        const n = Number(val)
        return n >= 18 && n <= 100
      }),
    fatherAddress1: Yup.string().trim().required("Father's address is required"),
    fatherCity: Yup.string().trim().required("Father's city is required"),
    motherName: Yup.string().trim().required("Mother's name is required"),
    motherContact: Yup.string().required("Mother's contact is required"),
    // .matches(/^[6-9]\d{9}$/, 'Enter valid 10-digit number'),
    motherAge: Yup.string()
      .required("Mother's age is required")
      .matches(/^\d+$/, 'Age must be numbers only')
      .test('len', 'Age must be 2 or 3 digits', (val) => val.length >= 2 && val.length <= 3)
      .test('range', 'Age 18–100', (val) => {
        const n = Number(val)
        return n >= 18 && n <= 100
      }),
  })

  const handleNext = async () => {
    // Get current step validation schema
    let currentSchema
    let currentStepFields = stepFields[step] || []

    switch (step) {
      case 1:
        currentSchema = step1Schema
        break
      case 2:
        currentSchema = step2Schema
        break
      // case 3:
      //   currentSchema = step3Schema
      //   break
      case 4:
        currentSchema = step4Schema
        break
      case 5:
        currentSchema = step5Schema
        break
      case 6:
        currentSchema = step6Schema
        break
      case 7:
        currentSchema = step7Schema
        break
      default:
        currentSchema = null
    }

    if (currentSchema) {
      try {
        // Create validation object with only current step fields
        const validationObject = {}
        currentStepFields.forEach((field) => {
          validationObject[field] = formik.values[field]
        })

        // Validate only the fields for this step
        await currentSchema.validate(validationObject, { abortEarly: false })

        // Mark fields as touched
        const touchedFields = {}
        currentStepFields.forEach((field) => {
          touchedFields[field] = true
        })
        formik.setTouched({ ...formik.touched, ...touchedFields })

        // Move to next step
        setStep((prev) => prev + 1)
      } catch (errors) {
        // Show all validation errors
        if (errors.inner) {
          errors.inner.forEach((error) => {
            toast.error(error.message)
          })
        } else {
          toast.error('Please fill all required fields')
        }

        // Mark fields as touched to show validation UI
        const touchedFields = {}
        if (errors.inner) {
          errors.inner.forEach((error) => {
            touchedFields[error.path] = true
          })
        } else {
          currentStepFields.forEach((field) => {
            touchedFields[field] = true
          })
        }
        formik.setTouched({ ...formik.touched, ...touchedFields })
      }
    } else {
      setStep((prev) => prev + 1)
    }
  }

  // const validationSchema = Yup.object({})
  const handleSubmit = async () => {
    dispatch(setLoader(true))

    try {
      // Validate all steps before final submission
      try {
        await step1Schema.validate(formik.values, { abortEarly: false })
        await step2Schema.validate(formik.values, { abortEarly: false })
        // await step3Schema.validate(formik.values, { abortEarly: false })
        await step4Schema.validate(formik.values, { abortEarly: false })
        await step5Schema.validate(formik.values, { abortEarly: false })
        await step7Schema.validate(formik.values, { abortEarly: false })
        // step6 is optional, so skip validation
      } catch (validationError) {
        if (validationError.inner) {
          validationError.inner.forEach((e) => toast.error(e.message))
        }
        dispatch(setLoader(false))
        return
      }

      // School check for non-admin
      if (customRole !== 'Admin' && !formik.values.schoolName) {
        toast.error('School is required')
        dispatch(setLoader(false))
        return
      }

      let uploadedStudentImageUrl = formik.values.studentImage
      let uploadedFatherAadharUrl = formik.values.fatherImage
      let uploadedMotherAadharUrl = formik.values.motherImage
      let uploadedStudentAadharUrl = formik.values.aadharImage
      let uploadedBirthCertificateUrl = formik.values.birthCertificate
      let uploadedTcUrl = formik.values.tc
      let uploadedMarksheetUrl = formik.values.prev_marksheet

      // Helper to upload if it's a new blob file
      const uploadIfNew = async (fileValue) => {
        // If it's already a string (URL from previous upload / edit mode) → return as-is
        if (typeof fileValue === 'string' && fileValue) {
          return fileValue
        }

        // If it's a File object (freshly selected in this form session)
        if (fileValue instanceof File) {
          try {
            const uploadedUrl = await uploadImageToS3(fileValue, 'student')
            return uploadedUrl
          } catch (err) {
            console.error('Image upload failed:', err)
            toast.error('Failed to upload one of the images')
            throw err // or return null / '' — depending on your needs
          }
        }

        // Otherwise (null, undefined, empty string, etc.)
        return null
      }

      uploadedStudentImageUrl = await uploadIfNew(formik.values.studentImage, 'studentImageInput')
      uploadedFatherAadharUrl = await uploadIfNew(formik.values.fatherImage, 'fatherImageInput')
      uploadedMotherAadharUrl = await uploadIfNew(formik.values.motherImage, 'motherImageInput')
      uploadedStudentAadharUrl = await uploadIfNew(formik.values.aadharImage, 'aadharImageInput')
      uploadedBirthCertificateUrl = await uploadIfNew(
        formik.values.birthCertificate,
        'birthCertInput',
      )
      uploadedTcUrl = await uploadIfNew(formik.values.tc, 'tcInput')
      uploadedMarksheetUrl = await uploadIfNew(formik.values.prev_marksheet, 'marksheetInput')

      // ── Prepare payload ───────────────────────────────────────────
      const studentData = {
        school_id: customRole === 'Admin' ? userSchoolId : formik.values.schoolName,
        registration_number: formik.values.studentRollNo,
        name: formik.values.studentName,
        dob: formik.values.dob,
        section_map_id: sectionMapID,
        gender: formik.values.gender,
        section_id: formik.values.section,
        grade_id: formik.values.gradeVal,
        address: formik.values.address1,
        city: formik.values.city,
        state: formik.values.state,
        pincode: formik.values.zipCode,
        father_name: formik.values.fatherName,
        father_contact: formik.values.fatherContact,
        alternate_contact_number: formik.values.alternateContact,
        mother_name: formik.values.motherName,
        caste: formik.values.caste,
        discount: Number(formik.values.discountFee) || 0,
        transport_fee: Number(formik.values.transportFee) || 0,
        // category: formik.values.category || '',
        batch: formik.values.batch,
        admission_month: formik.values.admission_month,
        van_facility: formik.values.van_facility === 'required' ? true : false,
        avatar: uploadedStudentImageUrl ?? '',
        aadhar_url: uploadedStudentAadharUrl ?? '',
        email: formik.values.email,
        father_email: formik.values.father_email,
        apaar_id: formik.values.appar_id,
        pen_id: formik.values.pen,
        certification_url: uploadedBirthCertificateUrl ?? '',
        mother_image: uploadedMotherAadharUrl ?? '',
        father_image: uploadedFatherAadharUrl ?? '',
        van_id: formik.values.van,
        stop_id: formik.values.stop,
        route_id: formik.values.route,
        transport_start_month: formik.values.transport_start_month,
        transport_end_month: formik.values.transport_end_month,
        f_age: formik.values.fatherAge,
        f_aadhar_no: formik.values.fatherAadhar,
        mother_age: formik.values.motherAge,
        mother_aadhar: formik.values.motherAadhar,
        p_address: formik.values.fatherAddress1,
        p_address2: formik.values.fatherAddress2,
        p_city: formik.values.fatherCity,
        p_state: formik.values.fatherState,
        p_pin_code: formik.values.fatherZip,
        ps_name: formik.values.prev_school,
        ps_city: formik.values.prev_school_city,
        ps_board: formik.values.prev_school_board,
        ps_mob: formik.values.prev_school_mobile_number,
        ps_tc_url: uploadedTcUrl ?? '',
        ps_marksheet_url: uploadedMarksheetUrl ?? '',
        aadhar_number: formik.values.aadharNumber ?? '',
      }

      const response = await postApi(urls.STUDENT_POST, studentData)

      if (response.status === 201 || response.status === 200) {
        const { student_id } = response.data
        setStudentId(student_id)
        toast.success('Student Added Successfully!')
        setSuccess(true)
        // dispatch(setRefreshPage(true))
      } else {
        toast.error(response.message || response.error?.message || 'Failed to add student')
      }
    } catch (err) {
      if (err.inner) {
        err.inner.forEach((e) => toast.error(e.message))
      } else {
        toast.error('Something went wrong!')
        console.error(err)
      }
    } finally {
      dispatch(setLoader(false))
    }
  }

  // const onStep2 = () => {
  //   validationSchema2
  //     .validate(formik.values, { abortEarly: false })
  //     .then(() => {
  //       if (
  //         !/^\d{10}$/.test(formik.values.fatherContact) ||
  //         formik.values.fatherContact.startsWith('0')
  //       ) {
  //         toast.error('Invalid Phone Number!')
  //         dispatch(setLoader(false))
  //         return
  //       }
  //       if (formik.values.zipCode && formik.values.zipCode.length !== 6) {
  //         toast.error('Zipcode must be 6 digits!')
  //         dispatch(setLoader(false))
  //         return
  //       }
  //       if (formik.values.aadharNumber) {
  //         if (formik.values.aadharNumber.length != 12) {
  //           toast.error('Aadhar Number Must be 12 digits.')
  //           dispatch(setLoader(false))
  //           return
  //         }
  //       }
  //       handleNext()
  //     })
  //     // .catch((errors) => {
  //     //   const errorMessages = errors.inner.map((error) => error.message)
  //     //   const errorList = errorMessages.map((errorMessage) => `• ${errorMessage}`).join('<br>')
  //     //   toast.error(`Please fix the following errors:\n${errorList}`)
  //     // })
  //     .catch((errors) => {
  //       errors?.inner?.forEach((error) => {
  //         toast.error(error.message)
  //       })
  //     })
  // }
  const formik = useFormik({
    initialValues,
    // validationSchema: validationSchema2,
    onSubmit: handleSubmit,
  })

  // console.log('----formik',formik.values.fatherContact);
  // console.log('----formiktype',typeof(formik.values.fatherContact));

  // const handleNext = () => {
  //   setStep((prevStep) => {
  //     const nextStep = prevStep + 1

  //     if (nextStep >= 8) {
  //       // When we would go to step 8 or beyond → show success
  //       setSuccess(true)
  //       // You can choose:
  //       // Option A: stay on step 8
  //       return 8
  //       // Option B: don't change step at all
  //       // return prevStep;
  //     }

  //     // Normal case
  //     return nextStep
  //   })
  // }
  const handlePrev = () => {
    setStep(1)
  }
  const ProgressRate = (step) => {
    const progress = Math.min(Math.max(step, 1), 7) // clamp between 1–7
    const percentage = ((progress - 1) / 6) * 100
    return `${Math.round(percentage)}%`
  }

  if (success) {
    return <StudentSucess handleClose={handleClose} />
  }
  const stepTitles = [
    'Basic Information', // step 1
    'Contact Information', // step 2
    'Important Documents', // step 3
    'Assign Class', // step 4
    'Transport Information', // step 5
    'Previous School Details', // step 6
    'Parent Information', // step 7
  ]

  // Optional: fallback + safety
  const currentTitle = stepTitles[step - 1] || 'Student Registration'
  return (
    <div
      style={{
        maxHeight: 'unset',
        gap: '20px',
        display: 'flex',
        flexDirection: 'column',
        width: '100%',
        overflow: 'unset',
      }}
      className="add-employee"
    >
      <div className="header-registration">
        <div onClick={handleClose} className="back-box">
          <img
            src={backarrow}
            alt=""
            style={{
              width: '36px',
              height: '36px',
            }}
          />
          <p>Back</p>
        </div>
        <div className="linear-progress">
          <div className="linear-p-bar">
            <div className="filled-area" style={{ width: ProgressRate(step) }}></div>
          </div>
          <Typography>{step}/7</Typography>
        </div>
      </div>
      <div className="header-registration">
        <Typography className="student-heading">{currentTitle}</Typography>
      </div>
      {step == 1 && (
        <Step1
          customRole={customRole}
          userSchoolId={userSchoolId}
          formik={formik}
          onCancel={() => handleClose()}
          onNext={handleNext}
          handleFileChange={handleFileChange}
          setSectionMapID={setSectionMapID}
        />
      )}
      {step == 2 && <Step2 formik={formik} onNext={handleNext} onPrev={handlePrev} />}
      {step == 3 && <Step3 formik={formik} onNext={handleNext} onPrev={handlePrev} />}
      {step == 4 && (
        <Step4
          formik={formik}
          onNext={handleNext}
          onPrev={handlePrev}
          userSchoolId={userSchoolId}
          customRole={customRole}
          setSectionMapID={setSectionMapID}
        />
      )}
      {step == 5 && (
        <Step5
          formik={formik}
          onNext={handleNext}
          onPrev={handlePrev}
          userSchoolId={userSchoolId}
          customRole={customRole}
        />
      )}
      {step == 6 && (
        <Step6
          formik={formik}
          onNext={handleNext}
          onPrev={handlePrev}
          userSchoolId={userSchoolId}
          customRole={customRole}
        />
      )}
      {step == 7 && (
        <Step7
          formik={formik}
          // onNext={handleNext}
          onPrev={handlePrev}
          userSchoolId={userSchoolId}
          customRole={customRole}
          onSubmit={handleSubmit}
        />
      )}
      {/* {step == 2 && (
        <Step3 formik={formik} handlePrev={() => handlePrev()} onSubmit={handleSubmit} />
      )} */}
    </div>
  )
}

export default StudentForm

const Step1 = ({
  formik,
  onNext,
  onCancel,
  handleFileChange,
  setSectionMapID,
  customRole,
  userSchoolId,
}) => {
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const { data: gradeList } = useGlobal({
    userUrl: `${urls.GRADE_LIST}${customRole == 'Admin' ? userSchoolId : formik.values.schoolName}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [GradeMapId, setGradeMapId] = useState()
  const handleGradeChange = (selectedOption) => {
    formik.setFieldValue('gradeVal', selectedOption)
    const selectedGrade = gradeList?.find((grade) => grade.grade_id === selectedOption)

    if (selectedGrade) {
      setGradeMapId(selectedGrade.grade_map_id)
    }
  }
  const handleSectionChange = (selectedOption) => {
    formik.setFieldValue('section', selectedOption)
    const selectedSection = sectionList?.find((section) => section.section_id === selectedOption)

    if (selectedSection) {
      setSectionMapID(selectedSection.section_map_id)
    }
  }
  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value
    formik.setFieldValue(fieldName, numericValue)
  }
  const handleStringInputChange = (fieldName) => (e) => {
    const stringValue = e.target.value.replace(/[^a-zA-Z\s]/g, '')
    formik.setFieldValue(fieldName, stringValue)
  }
  const handleCategoryChange = (selectedOption) => {
    formik.setFieldValue('caste', selectedOption)
  }
  return (
    <div>
      <ImageUpload
        label={'Student Photo'}
        selectedImage={
          formik.values.studentImage && URL.createObjectURL(formik.values.studentImage)
        }
        onFileChange={(e) => handleFileChange(e, 'studentImage')}
      />
      <TextFields
        required
        label={'Name'}
        placeholder={'Student Name'}
        name={'studentName'}
        value={formik.values.studentName}
        onChange={formik.handleChange}
      />
      <div className="text-fields">
        <TextFields
          required
          width={'100%'}
          label={'Registration Number'}
          name={'studentRollNo'}
          placeholder={'Enter Reg. No'}
          value={formik.values.studentRollNo}
          onChange={formik.handleChange}
        />
        <TextFields
          width={'100%'}
          label={'Batch'}
          name={'batch'}
          placeholder={'Enter Batch'}
          value={formik.values.batch}
          onChange={handleInputChange('batch')}
          required
        />
      </div>

      <SelectField
        label={'Admission Month'}
        required
        options={(monthOptions || [])?.map((prod) => ({
          value: prod.value,
          label: prod.label,
        }))}
        width={'100%'}
        name="admission_month"
        value={formik.values.admission_month}
        onChange={(selectedOption) => formik.setFieldValue('admission_month', selectedOption)}
      />
      <SelectField
        label={'Gender'}
        required
        options={(genderOptions || [])?.map((prod) => ({
          value: prod.value,
          label: prod.label,
        }))}
        width={'100%'}
        name="gender"
        value={formik.values.gender}
        onChange={(selectedOption) => formik.setFieldValue('gender', selectedOption)}
      />

      <div className="text-fields">
        <DateInput
          required
          label={'Date of Birth'}
          value={formik.values.dob}
          name={'dob'}
          isflex={true}
          onChange={formik.handleChange}
        />
      </div>
      <SelectField
        label={'Caste'}
        options={(categoryOptions || [])?.map((prod) => ({
          value: prod.value,
          label: prod.label,
        }))}
        width={'100%'}
        required
        name="caste"
        value={formik.values.caste}
        onChange={(selectedOption) => handleCategoryChange(selectedOption)}
        isflex={true}
      />
      <Buttons student={true} text={'Cancel'} onNext={onNext} onPrev={onCancel} />
    </div>
  )
}
const Step2 = ({
  formik,
  onNext,
  onCancel,
  handleFileChange,
  setSectionMapID,
  customRole,
  userSchoolId,
}) => {
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const { data: gradeList } = useGlobal({
    userUrl: `${urls.GRADE_LIST}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : formik.values.schoolName}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [GradeMapId, setGradeMapId] = useState()
  const handleGradeChange = (selectedOption) => {
    formik.setFieldValue('gradeVal', selectedOption)
    const selectedGrade = gradeList?.find((grade) => grade.grade_id === selectedOption)

    if (selectedGrade) {
      setGradeMapId(selectedGrade.grade_map_id)
    }
  }
  const handleSectionChange = (selectedOption) => {
    formik.setFieldValue('section', selectedOption)
    const selectedSection = sectionList?.find((section) => section.section_id === selectedOption)

    if (selectedSection) {
      setSectionMapID(selectedSection.section_map_id)
    }
  }
  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value
    formik.setFieldValue(fieldName, numericValue)
  }
  const handleStringInputChange = (fieldName) => (e) => {
    const stringValue = e.target.value.replace(/[^a-zA-Z\s]/g, '')
    formik.setFieldValue(fieldName, stringValue)
  }
  const handleCategoryChange = (selectedOption) => {
    formik.setFieldValue('category', selectedOption)
  }
  const handleEmailChange = (fieldName) => (e) => {
    // Allow letters, numbers, @ . - _ +
    const allowedValue = e.target.value.replace(/[^a-zA-Z0-9@._+-]/g, '')
    formik.setFieldValue(fieldName, allowedValue)
  }
  return (
    <div>
      {/* <div className="text-fields">
        {customRole == 'Admin' || customRole === 'Superadmin' ? (
          <InfoField label={'School'} value={userSchoolName} width={'250px'} />
        ) : (
          <SelectField
            required
            label={'School'}
            options={(schoolList || [])?.map((prod) => ({
              value: prod.school_id,
              label: prod.school_name,
            }))}
            width={'100%'}
            name="schoolName"
            value={formik.values.schoolName}
            onChange={(selectedOption) => formik.setFieldValue('schoolName', selectedOption)}
          />
        )}
      </div> */}

      <div className="text-fields">
        <TextFields
          label={'Phone Number (primary)'}
          width={'100%'}
          required
          placeholder={'Enter 10 digit number'}
          name={'fatherContact'}
          value={formik.values.fatherContact || ''}
          onChange={handleInputChange('fatherContact')}
        />
        <TextFields
          label={'Phone Number (secondary)'}
          width={'100%'}
          placeholder={'Enter 10 digit number'}
          name={'alternateContact'}
          value={formik.values.alternateContact}
          onChange={handleInputChange('alternateContact')}
        />
      </div>
      <TextFields
        label={'Emergency Phone Number (primary)'}
        width={'100%'}
        placeholder={'Enter 10 digit number'}
        name={'emergencyNumber'}
        value={formik.values.emergencyNumber}
        onChange={handleInputChange('emergencyNumber')}
      />
      <TextFields
        label={'Email'}
        width={'100%'}
        placeholder={'Enter Student’s or Parent’s email Address'}
        name={'email'}
        value={formik.values.email}
        onChange={handleEmailChange('email')}
        // required={true}
      />
      <div className="header-registration">
        <Typography className="student-heading">Permanent Address</Typography>
      </div>
      <div
        style={{
          marginTop: '20px',
        }}
        className="text-fields"
      >
        <TextFields
          required
          label={'Address'}
          width={'100%'}
          placeholder={'Enter Student’s permanent Address'}
          name={'address1'}
          value={formik.values.address1}
          onChange={formik.handleChange}
          height={'96px'}
        />
      </div>
      <div className="text-fields">
        <TextFields
          required
          label={'City'}
          placeholder={'Enter City'}
          width={'40%'}
          name={'city'}
          value={formik.values.city}
          onChange={handleStringInputChange('city')}
        />
        <TextFields
          required
          label={'State'}
          placeholder={'Enter State'}
          width={'120px'}
          name={'state'}
          value={formik.values.state}
          onChange={handleStringInputChange('state')}
        />
        <TextFields
          required
          label={'Pincode'}
          width={'120px'}
          placeholder={'XXXXXX'}
          name={'zipCode'}
          value={formik.values.zipCode}
          onChange={handleInputChange('zipCode')}
        />
      </div>

      <Buttons student={true} text={'Cancel'} onNext={onNext} onPrev={onCancel} />
    </div>
  )
}
const Step3 = ({
  formik,
  onNext,
  onCancel,
  handleFileChange,
  setSectionMapID,
  customRole,
  userSchoolId,
}) => {
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const { data: gradeList } = useGlobal({
    userUrl: `${urls.GRADE_LIST}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : formik.values.schoolName}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [GradeMapId, setGradeMapId] = useState()
  const handleGradeChange = (selectedOption) => {
    formik.setFieldValue('gradeVal', selectedOption)
    const selectedGrade = gradeList?.find((grade) => grade.grade_id === selectedOption)

    if (selectedGrade) {
      setGradeMapId(selectedGrade.grade_map_id)
    }
  }
  const handleSectionChange = (selectedOption) => {
    formik.setFieldValue('section', selectedOption)
    const selectedSection = sectionList?.find((section) => section.section_id === selectedOption)

    if (selectedSection) {
      setSectionMapID(selectedSection.section_map_id)
    }
  }
  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value
    formik.setFieldValue(fieldName, numericValue)
  }

  const handleAadharChange = createFileChangeHandler(formik, 'aadharImage', '')
  const handleBirthCertifcateChange = createFileChangeHandler(formik, 'birthCertificate', '')

  return (
    <div>
      {/* <div className="text-fields">
        {customRole == 'Admin' || customRole === 'Superadmin' ? (
          <InfoField label={'School'} value={userSchoolName} width={'250px'} />
        ) : (
          <SelectField
            required
            label={'School'}
            options={(schoolList || [])?.map((prod) => ({
              value: prod.school_id,
              label: prod.school_name,
            }))}
            width={'100%'}
            name="schoolName"
            value={formik.values.schoolName}
            onChange={(selectedOption) => formik.setFieldValue('schoolName', selectedOption)}
          />
        )}
      </div> */}

      <div className="text-fields">
        <TextFields
          label={'PEN (Permanent Education Number)'}
          width={'100%'}
          // required
          placeholder={'Enter pen Number'}
          name={'pen'}
          value={formik.values.pen}
          onChange={handleInputChange('pen')}
        />
        <TextFields
          label={'Apaar ID'}
          width={'100%'}
          // required={true}
          placeholder={'Enter Apaar Number'}
          name={'appar_id'}
          value={formik.values.appar_id}
          onChange={handleInputChange('appar_id')}
        />
      </div>
      {/* <TextFields
        label={'Emergency Phone Number (primary)'}
        width={'100%'}
        placeholder={'Enter 10 digit number'}
        name={'emergencyNumber'}
        value={formik.values.emergencyNumber}
        onChange={handleInputChange('alternateContact')}
      /> */}
      <TextFields
        label={'Aadhar (Front)'}
        width={'100%'}
        placeholder={'Enter Student Aadhar Number'}
        name={'aadharNumber'}
        value={formik.values.aadharNumber}
        onChange={formik.handleChange}
        margin={0}
        studentForm
        // required
      />
      <AadharImage
        margin={0}
        studentForm
        fileName={
          // preferred (clean string)
          formik.values.aadharImage?.name || // fallback if you don't use tcName
          'No file chosen'
        }
        onFileChange={handleAadharChange}
        Aadhar
        required
      />
      <AadharImage
        // margin={0}
        label={'Birth certificate'}
        fileName={
          // preferred (clean string)
          formik.values.birthCertificate?.name || // fallback if you don't use tcName
          'No file chosen'
        }
        onFileChange={handleBirthCertifcateChange}
        // required={true}
      />
      <Buttons student={true} text={'Cancel'} onNext={onNext} onPrev={onCancel} />
    </div>
  )
}
const Step4 = ({
  formik,
  onNext,
  onCancel,
  handleFileChange,
  setSectionMapID,
  customRole,
  userSchoolId,
}) => {
  // const { data: schoolList } = useGlobal({
  //   userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  // })
  // console.log('---userSchoolId',userSchoolId);

  const { data: gradeList } = useGlobal({
    userUrl: `${urls.GRADE_LIST}${customRole == 'Admin' ? userSchoolId : formik.values.schoolName}`,
  })
  // console.log('---gradeList',gradeList);

  // const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [GradeMapId, setGradeMapId] = useState()
  const handleGradeChange = (selectedOption) => {
    formik.setFieldValue('gradeVal', selectedOption)
    const selectedGrade = gradeList?.find((grade) => grade.grade_id === selectedOption)

    if (selectedGrade) {
      setGradeMapId(selectedGrade.grade_map_id)
    }
  }
  const handleSectionChange = (selectedOption) => {
    formik.setFieldValue('section', selectedOption)
    const selectedSection = sectionList?.find((section) => section.section_id === selectedOption)

    if (selectedSection) {
      setSectionMapID(selectedSection.section_map_id)
    }
  }
  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value
    formik.setFieldValue(fieldName, numericValue)
  }
  const handleStringInputChange = (fieldName) => (e) => {
    const stringValue = e.target.value.replace(/[^a-zA-Z\s]/g, '')
    formik.setFieldValue(fieldName, stringValue)
  }
  const handleCategoryChange = (selectedOption) => {
    formik.setFieldValue('category', selectedOption)
  }
  const handleNumericChange = (fieldName) => (e) => {
    const value = e.target.value
    // Allow only numbers and empty string
    if (value === '' || /^\d+$/.test(value)) {
      formik.setFieldValue(fieldName, value)
    }
  }
  return (
    <div>
      <div className="text-fields">
        <SelectField
          label={''}
          options={(gradeList || [])?.map((prod) => ({
            value: prod.grade_id,
            label: prod.grade,
          }))}
          width={'100%'}
          // required
          name="gradeVal"
          value={formik.values.gradeVal}
          onChange={(selectedOption) => handleGradeChange(selectedOption)}
          subLabel={'Grade :'}
        />
        <SelectField
          label={''}
          options={(sectionList || [])?.map((prod) => ({
            value: prod.section_id,
            label: prod.section,
          }))}
          width={'100%'}
          // required
          name="section"
          subLabel={'Class :'}
          value={formik.values.section}
          onChange={(selectedOption) => handleSectionChange(selectedOption)}
        />
      </div>
      <TextFields
          label={'Discount Fees'}
          width={'50%'}
          // required
          placeholder={'Enter discount fees'}
          name={'discountFee'}
          value={formik.values.discountFee || ''}
          onChange={handleInputChange('discountFee')}
        />
      <Buttons student={true} text={'Cancel'} onNext={onNext} onPrev={onCancel} />
    </div>
  )
}

const Step5 = ({
  formik,
  onNext,
  onCancel,
  handleFileChange,
  setSectionMapID,
  customRole,
  userSchoolId,
}) => {
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const { data: routeData, count } = useGlobal({
    userUrl: `${urls.ROUTE_GET}${customRole == 'Admin' ? userSchoolId : formik.values.schoolName}&page=1&limit=10000`,
  })
  const { data: vanData } = useGlobal({
    userUrl: `${urls.VAN_GET}${customRole == 'Admin' ? userSchoolId : formik.values.schoolName}&page=1&limit=10000&isAssign=true&route_id=${formik?.values?.route}`,
  })
  const { data: stopData } = useGlobal({
    userUrl: `${urls.STOP_GET}${formik.values.route}`,
  })

  // console.log('----stopData',stopData);

  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [GradeMapId, setGradeMapId] = useState()
  const handleRouteChange = (selectedOption) => {
    formik.setFieldValue('route', selectedOption)
  }
  const handleStopChange = (selectedOption) => {
    formik.setFieldValue('stop', selectedOption)
  }
  const handleVanChange = (selectedOption) => {
    formik.setFieldValue('van', selectedOption)
  }
  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value
    formik.setFieldValue(fieldName, numericValue)
  }
  const [selectedValue, setSelectedValue] = React.useState(
    formik.values.van_facility === true ? 'required' : 'not_required',
  )

  // Sync local state when formik value changes externally
  React.useEffect(() => {
    setSelectedValue(formik.values.van_facility ? 'required' : 'not_required')
  }, [formik.values.van_facility])

  const handleRadioChange = (event) => {
    const value = event.target.value
    const boolValue = value === 'required' // 'required' → true, 'not_required' → false
    formik.setFieldValue('van_facility', boolValue)
    setSelectedValue(value)
  }
  return (
    <div
      style={{
        width: '100%',
      }}
    >
      <div
        style={{
          width: '100%',
          justifyContent: 'space-between',
        }}
        className="text-fields van-facility-group"
      >
        <FormControl
          sx={{
            width: '100%',
            justifyContent: 'space-between',
          }}
          component="fieldset"
        >
          <RadioGroup
            aria-label="van-facility"
            name="van-facility-radio"
            value={selectedValue}
            onChange={handleRadioChange}
            row // ← This makes them horizontal
            sx={{
              flexDirection: 'row',
              justifyContent: 'space-between', // space between the two options — adjust as needed (1.5rem, 32px, 3rem, etc.)
              // or use justifyContent: 'space-between' if you want them pushed to edges
              // justifyContent: 'space-between',
            }}
          >
            <FormControlLabel
              value="required"
              control={<Radio color="primary" />}
              label="Required"
              sx={{
                color: 'black',
                '& .MuiFormControlLabel-label': {
                  color: 'black',
                },
                '&.Mui-checked .MuiFormControlLabel-label': {
                  color: 'black',
                },
                color: '#2970FE',
                '&.Mui-checked': {
                  color: '#2970FE', // or keep #fff if that's your design
                },
              }}
            />
            <FormControlLabel
              value="not_required"
              control={<Radio />}
              label="Not Required"
              sx={{
                color: 'black', // label text color
                '& .MuiFormControlLabel-label': {
                  color: 'black', // more reliable way to target label text
                },
                '&.Mui-checked .MuiFormControlLabel-label': {
                  color: 'black', // keep black even when checked
                },
                color: '#2970FE',
                '&.Mui-checked': {
                  color: '#2970FE', // or keep #fff if that's your design
                },
                // Optional: make checked state more visible via radio color only
              }}
            />
          </RadioGroup>
        </FormControl>
      </div>

      {selectedValue === 'required' && (
        <>
          <SelectField
            label={'Route'}
            options={(routeData || [])?.map((prod) => ({
              value: prod.route_id,
              label: prod.route_name,
            }))}
            width={'100%'}
            required
            name="route"
            value={formik.values.route}
            onChange={(selectedOption) => handleRouteChange(selectedOption)}
            subLabel={''}
            placeholder={'Select'}
          />

          <SelectField
            label={'Stop'}
            options={(stopData || [])?.map((prod) => ({
              value: prod.stop_id,
              label: prod.stop_address,
            }))}
            width={'100%'}
            required
            name="stop"
            placeholder={'Select'}
            subLabel={''}
            value={formik.values.stop}
            onChange={(selectedOption) => handleStopChange(selectedOption)}
          />
          <SelectField
            label={'Van'}
            options={(vanData || [])?.map((prod) => ({
              value: prod.van_id,
              label: prod.van_number,
            }))}
            width={'100%'}
            required
            name="van"
            placeholder={'Select'}
            subLabel={''}
            value={formik.values.van}
            onChange={(selectedOption) => handleVanChange(selectedOption)}
          />
          <SelectField
            label={'Start Month'}
            required
            options={(monthOptions || [])?.map((prod) => ({
              value: prod.value,
              label: prod.label,
            }))}
            width={'100%'}
            name="transport_start_month"
            value={formik.values.transport_start_month}
            onChange={(selectedOption) =>
              formik.setFieldValue('transport_start_month', selectedOption)
            }
          />
          <SelectField
            label={'End Month'}
            required
            options={(monthOptions || [])?.map((prod) => ({
              value: prod.value,
              label: prod.label,
            }))}
            width={'100%'}
            name="transport_end_month"
            value={formik.values.transport_end_month}
            onChange={(selectedOption) =>
              formik.setFieldValue('transport_end_month', selectedOption)
            }
          />
          {/* <DateInput value={formik.values.effect_from} label={'With Effect From'} required={true} /> */}
        </>
      )}

      {/* Keep your other fields here if any */}

      <Buttons student={true} text={'Cancel'} onNext={onNext} onPrev={onCancel} />
    </div>
  )
}
const Step6 = ({
  formik,
  onNext,
  onCancel,
  handleFileChange,
  setSectionMapID,
  customRole,
  userSchoolId,
}) => {
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const { data: gradeList } = useGlobal({
    userUrl: `${urls.GRADE_LIST}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : formik.values.schoolName}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [GradeMapId, setGradeMapId] = useState()
  const handleGradeChange = (selectedOption) => {
    formik.setFieldValue('gradeVal', selectedOption)
    const selectedGrade = gradeList?.find((grade) => grade.grade_id === selectedOption)

    if (selectedGrade) {
      setGradeMapId(selectedGrade.grade_map_id)
    }
  }
  const handleSectionChange = (selectedOption) => {
    formik.setFieldValue('section', selectedOption)
    const selectedSection = sectionList?.find((section) => section.section_id === selectedOption)

    if (selectedSection) {
      setSectionMapID(selectedSection.section_map_id)
    }
  }
  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value
    formik.setFieldValue(fieldName, numericValue)
  }
  const handleTcChange = createFileChangeHandler(formik, 'tc', '')
  const handlePrevMarksheetChange = createFileChangeHandler(formik, 'prev_marksheet', '')

  return (
    <div>
      <TextFields
        label={'School Name'}
        width={'100%'}
        placeholder={'Enter School Name'}
        name={'prev_school'}
        value={formik.values.prev_school}
        onChange={formik.handleChange}
      />
      <TextFields
        label={'School City'}
        width={'100%'}
        placeholder={'Enter City'}
        name={'prev_school_city'}
        value={formik.values.prev_school_city}
        onChange={formik.handleChange}
      />

      <TextFields
        label={'School Board'}
        width={'100%'}
        placeholder={'Enter School Board'}
        name={'prev_school_board'}
        value={formik.values.prev_school_board}
        onChange={formik.handleChange}
      />
      <TextFields
        label={'School Mobile Number'}
        width={'100%'}
        placeholder={'Enter School Mobile Number'}
        name={'prev_school_mobile_number'}
        value={formik.values.prev_school_mobile_number}
        onChange={formik.handleChange}
      />

      <AadharImage
        // margin={0}
        label="Transfer Certificate (TC)"
        fileName={
          // preferred (clean string)
          formik.values.tc?.name || // fallback if you don't use tcName
          'No file chosen'
        }
        onFileChange={handleTcChange}
        // value={formik.values.tc}
      />
      <AadharImage
        // margin={0}
        label="Result/Marksheet form previous class"
        fileName={
          // preferred (clean string)
          formik.values.prev_marksheet?.name || // fallback if you don't use tcName
          'No file chosen'
        }
        onFileChange={handlePrevMarksheetChange}
        // value={formik.values.tc}
      />
      <Buttons student={true} text={'Cancel'} skip onNext={onNext} onPrev={onCancel} />
    </div>
  )
}
const Step7 = ({
  formik,
  onNext,
  onCancel,
  handleFileChange,
  setSectionMapID,
  customRole,
  userSchoolId,
  onSubmit,
}) => {
  const { data: schoolList } = useGlobal({
    userUrl: `${urls.SCHOOL_LIST}?page=1&limit=${highestInt}`,
  })
  const { data: gradeList } = useGlobal({
    userUrl: `${urls.GRADE_LIST}${customRole == 'Admin' || customRole === 'Superadmin' ? userSchoolId : formik.values.schoolName}`,
  })
  const userSchoolName = schoolList?.find((school) => school.school_id == userSchoolId)?.school_name
  const [GradeMapId, setGradeMapId] = useState()
  const handleGradeChange = (selectedOption) => {
    formik.setFieldValue('gradeVal', selectedOption)
    const selectedGrade = gradeList?.find((grade) => grade.grade_id === selectedOption)

    if (selectedGrade) {
      setGradeMapId(selectedGrade.grade_map_id)
    }
  }
  const handleSectionChange = (selectedOption) => {
    formik.setFieldValue('section', selectedOption)
    const selectedSection = sectionList?.find((section) => section.section_id === selectedOption)

    if (selectedSection) {
      setSectionMapID(selectedSection.section_map_id)
    }
  }
  const { data: sectionList } = useGlobal({ userUrl: `${urls.SECTION_LIST}${GradeMapId}` })
  const handleInputChange = (fieldName) => (e) => {
    const numericValue = e.target.value
    formik.setFieldValue(fieldName, numericValue)
  }
  const handleMotherImageChange = createFileChangeHandler(formik, 'motherImage', '')
  const handleFatherImageChange = createFileChangeHandler(formik, 'fatherImage', '')
  const handleEmailChange = (fieldName) => (e) => {
    // Allow letters, numbers, @ . - _ +
    const allowedValue = e.target.value.replace(/[^a-zA-Z0-9@._+-]/g, '')
    formik.setFieldValue(fieldName, allowedValue)
  }
  const handleFatherCategoryChange = (selectedOption) => {
    formik.setFieldValue('fatherCaste', selectedOption)
  }
  //   const handleMotherCategoryChange = (selectedOption) => {
  //   formik.setFieldValue('fatherCaste', selectedOption)
  // }
  return (
    <div>
      <div className="text-fields">
        <TextFields
          label={`Father's Name`}
          width={'100%'}
          placeholder={'Enter Name'}
          name={'fatherName'}
          value={formik.values.fatherName}
          onChange={formik.handleChange}
          required
        />
        {/* <TextFields
          label={`Father's Contact `}
          width={'100%'}
          placeholder={'Enter Number'}
          name={'fatherContact'}
          value={formik.values.fatherContact}
          onChange={formik.handleChange}
          required
        /> */}
        <TextFields
          label={`Father’s Age`}
          width={'100%'}
          placeholder={'Enter Age'}
          name={'fatherAge'}
          value={formik.values.fatherAge}
          onChange={formik.handleChange}
          required
        />
      </div>

      <SelectField
        label={'Caste'}
        options={(categoryOptions || [])?.map((prod) => ({
          value: prod.value,
          label: prod.label,
        }))}
        width={'100%'}
        required
        name="fatherCaste"
        value={formik.values.fatherCaste}
        onChange={(selectedOption) => handleFatherCategoryChange(selectedOption)}
        isflex={true}
      />
      {/* <TextFields
          required
          label={'Caste'}
          width={'100%'}
          placeholder={'General'}
          name={'fatherCaste'}
          value={formik.values.fatherCaste}
          onChange={formik.handleChange}
        /> */}
      <TextFields
        label={`Aadhar Number`}
        width={'100%'}
        placeholder={'Enter Number'}
        name={'fatherAadhar'}
        value={formik.values.fatherAadhar}
        onChange={formik.handleChange}
        required
      />

      <TextFields
        label={`Father Email`}
        width={'100%'}
        placeholder={'Enter Father Email'}
        name={'father_email'}
        value={formik.values.father_email}
        onChange={formik.handleChange}
        required
      />
      <div className="text-fields">
        <TextFields
          label={'Address'}
          width={'100%'}
          placeholder={'Enter Address'}
          name={'fatherAddress1'}
          value={formik.values.fatherAddress1}
          onChange={formik.handleChange}
          required
        />
        <TextFields
          label={'Address 2'}
          width={'100%'}
          placeholder={'Enter Address'}
          name={'fatherAddress2'}
          value={formik.values.fatherAddress2}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <TextFields
          label={'City'}
          width={'100%'}
          placeholder={'Enter City'}
          name={'fatherCity'}
          value={formik.values.fatherCity}
          onChange={formik.handleChange}
          required
        />
        <TextFields
          label={'State'}
          width={'100%'}
          placeholder={'Enter State'}
          name={'fatherState'}
          value={formik.values.fatherState}
          onChange={formik.handleChange}
        />
        <TextFields
          label={'Zipcode'}
          width={'100%'}
          placeholder={'Enter Zipcode'}
          name={'fatherZip'}
          value={formik.values.fatherZip}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <TextFields
          label={`Mother's Name`}
          width={'100%'}
          placeholder={'Enter Name'}
          name={'motherName'}
          value={formik.values.motherName}
          onChange={formik.handleChange}
          required
        />
        <TextFields
          label={`Mother's Contact`}
          width={'100%'}
          placeholder={'Enter Number'}
          name={'motherContact'}
          value={formik.values.motherContact}
          onChange={formik.handleChange}
          required
        />
      </div>
      <div className="text-fields">
        <TextFields
          label={`Mother's Age`}
          width={'100%'}
          placeholder={'Enter Age'}
          name={'motherAge'}
          value={formik.values.motherAge}
          onChange={formik.handleChange}
          required
        />
        <TextFields
          label={`Aadhar Number`}
          width={'100%'}
          placeholder={'Enter Number'}
          name={'motherAadhar'}
          value={formik.values.motherAadhar}
          onChange={formik.handleChange}
          required
        />
      </div>
      {/* <div className="text-fields">
        <TextFields
          required
          label={'Caste'}
          width={'100%'}
          placeholder={'General'}
          name={'motherCaste'}
          value={formik.values.motherCaste}
          onChange={formik.handleChange}
        />
    
      </div>
      <div className="text-fields">
        <TextFields
          label={'Address'}
          width={'100%'}
          placeholder={'Enter School Board'}
          name={'motherAddress1'}
          value={formik.values.motherAddress1}
          onChange={formik.handleChange}
          required
        />
        <TextFields
          label={'Address 2'}
          width={'100%'}
          placeholder={'Enter School Mobile Number'}
          name={'motherAddress2'}
          value={formik.values.motherAddress2}
          onChange={formik.handleChange}
        />
      </div>
      <div className="text-fields">
        <TextFields
          label={'City'}
          width={'100%'}
          placeholder={'Enter City'}
          name={'motherCity'}
          value={formik.values.motherCity}
          onChange={formik.handleChange}
          required
        />
        <TextFields
          label={'State'}
          width={'100%'}
          placeholder={'Enter State'}
          name={'motherState'}
          value={formik.values.motherState}
          onChange={formik.handleChange}
        />
        <TextFields
          label={'Zipcode'}
          width={'100%'}
          placeholder={'Enter Zipcode'}
          name={'motherZip'}
          value={formik.values.motherZip}
          onChange={formik.handleChange}
        />
      </div> */}
      <AadharImage
        // margin={0}
        label="Father Image"
        fileName={
          // preferred (clean string)
          formik.values.fatherImage?.name || // fallback if you don't use tcName
          'No file chosen'
        }
        onFileChange={handleFatherImageChange}
        // value={formik.values.tc}
      />
      <AadharImage
        // margin={0}
        label="Mother Image"
        fileName={
          // preferred (clean string)
          formik.values.motherImage?.name || // fallback if you don't use tcName
          'No file chosen'
        }
        onFileChange={handleMotherImageChange}
        // value={formik.values.tc}
      />

      <Buttons student={true} text={'Cancel'} onNext={onSubmit} onPrev={onCancel} />
    </div>
  )
}
